export const appointmentConstants = {
  GETAPPOINTMENTS_LIST_REQUEST: "USERS_GETAPPOINTMENTS_LIST_REQUEST",
  GETAPPOINTMENTS_LIST_SUCCESS: "USERS_GETAPPOINTMENTS_LIST_SUCCESS",
  GETAPPOINTMENTS_LIST_FAILURE: "USERS_GETAPPOINTMENTS_LIST_FAILURE",

  SET_COUNSELLOR_STATUS_REQUEST: "SET_COUNSELLOR_STATUS_REQUEST",
  SET_COUNSELLOR_STATUS_SUCCESS: "SET_COUNSELLOR_STATUS_SUCCESS",
  SET_COUNSELLOR_STATUS_FAILURE: "SET_COUNSELLOR_STATUS_FAILURE",

  PATIENT_DETAIL_REQUEST: "PATIENT_DETAIL_REQUEST",
  PATIENT_DETAIL_SUCCESS: "PATIENT_DETAIL_SUCCESS",
  PATIENT_DETAIL_FAILURE: "PATIENT_DETAIL_FAILURE",

  GETPATIENTS_LIST_REQUEST: "USERS_GETPATIENTS_LIST_REQUEST",
  GETPATIENTS_LIST_SUCCESS: "USERS_GETPATIENTS_LIST_SUCCESS",
  GETPATIENTS_LIST_FAILURE: "USERS_GETPATIENTS_LIST_FAILURE",

  CREATEAPPOINTMENT_REQUEST: "USERS_CREATEAPPOINTMENT_REQUEST",
  CREATEAPPOINTMENT_SUCCESS: "USERS_CREATEAPPOINTMENT_SUCCESS",
  CREATEAPPOINTMENT_FAILURE: "USERS_CREATEAPPOINTMENT_FAILURE",

  CANCELAPPOINTMENT_REQUEST: "USERS_CANCELAPPOINTMENT_REQUEST",
  CANCELAPPOINTMENT_SUCCESS: "USERS_CANCELAPPOINTMENT_SUCCESS",
  CANCELAPPOINTMENT_FAILURE: "USERS_CANCELAPPOINTMENT_FAILURE",

  CREATEAPPOINTMENTS_REQUEST: "USERS_CREATEAPPOINTMENTS_REQUEST",
  CREATEAPPOINTMENTS_SUCCESS: "USERS_CREATEAPPOINTMENTS_SUCCESS",
  CREATEAPPOINTMENTS_FAILURE: "USERS_CREATEAPPOINTMENTS_FAILURE",

  DELETEAPPOINTMENTS_REQUEST: "USERS_DELETEAPPOINTMENTS_REQUEST",
  DELETEAPPOINTMENTS_SUCCESS: "USERS_DELETEAPPOINTMENTS_SUCCESS",
  DELETEAPPOINTMENTS_FAILURE: "USERS_DELETEAPPOINTMENTS_FAILURE",

  PATIENTS_LIST_REQUEST: "PATIENTS_LIST_REQUEST",
  PATIENTS_LIST_SUCCESS: "PATIENTS_LIST_SUCCESS",
  PATIENTS_LIST_FAILURE: "PATIENTS_LIST_FAILURE",

  
  COUNSELLOR_APPOINTMENTS_REQUEST: "COUNSELLOR_CREATEAPPOINTMENTS_REQUEST",
  COUNSELLOR_APPOINTMENTS_SUCCESS: "COUNSELLOR_CREATEAPPOINTMENTS_SUCCESS",
  COUNSELLOR_APPOINTMENTS_FAILURE: "COUNSELLOR_CREATEAPPOINTMENTS_FAILURE",

  
  COUNSELLOR_UPDATEAPPOINTMENTS_REQUEST: "COUNSELLOR_UPDATEAPPOINTMENTS_REQUEST",
  COUNSELLOR_UPDATEAPPOINTMENTS_SUCCESS: "COUNSELLOR_UPDATEAPPOINTMENTS_SUCCESS",
  COUNSELLOR_UPDATEAPPOINTMENTS_FAILURE: "COUNSELLOR_UPDATEAPPOINTMENTS_FAILURE",

  COUNSELLOR_UPDATEAPPOINTMENTS_RESET: "COUNSELLOR_UPDATEAPPOINTMENTS_RESET",
  
  GET_CALL_STATUS_SUCCESS: 'GET_CALL_STATUS_SUCCESS',
  GET_CALL_STATUS_FAILURE: 'GET_CALL_STATUS_FAILURE',


  USER_REQUEST_SESSION_REQUEST: "USER_REQUEST_SESSION_REQUEST",
  USER_REQUEST_SESSION_SUCCESS: "USER_REQUEST_SESSION_SUCCESS",
  USER_REQUEST_SESSION_FAILURE: "USER_REQUEST_SESSION_FAILURE",

  
  COUNSELLOR_REQUEST_APPOINTMENTS_REQUEST: "COUNSELLOR_REQUEST_APPOINTMENTS_REQUEST",
  COUNSELLOR_REQUEST_APPOINTMENTS_SUCCESS: "COUNSELLOR_REQUEST_APPOINTMENTS_SUCCESS",
  COUNSELLOR_REQUEST_APPOINTMENTS_FAILURE: "COUNSELLOR_REQUEST_APPOINTMENTS_FAILURE",
  
  PATIENT_REQUEST_ARRANGE_APPOINTMENTS_REQUEST: "PATIENT_REQUEST_ARRANGE_APPOINTMENTS_REQUEST",
  PATIENT_REQUEST_ARRANGE_APPOINTMENTS_SUCCESS: "PATIENT_REQUEST_ARRANGE_APPOINTMENTS_SUCCESS",
  PATIENT_REQUEST_ARRANGE_APPOINTMENTS_FAILURE: "PATIENT_REQUEST_ARRANGE_APPOINTMENTS_FAILURE",

  SESSION_CAPS_REQUEST: "SESSION_CAPS_REQUEST",
  SESSION_CAPS_SUCCESS: "SESSION_CAPS_SUCCESS",
  SESSION_CAPS_FAILURE: "SESSION_CAPS_FAILURE",

};



// WEBPACK FOOTER //
// ./src/store/constants/appointment.constants.js